<template>
  <div class="d-flex" v-if="data && data.filters">
    <app-filters
      ref="filters"
      v-if="data"
      :data="data"
      :endpoint="endpoint"
      v-model="filtersValue"
    ></app-filters>

    <filter-range-date v-if="range" v-model="filterDate" class="mr-2" style="max-width: 26em;"/>
    <button
      class="btn-filters btn btn-outline-primary"
      :class="{'btn-filters-dirty': hasFilters}"
      @click="showFilters"
    >
      <small>
        <font-awesome-icon icon="filter"/>
      </small>
      Фильтры
    </button>
  </div>
</template>

<script>
  import { isEmpty, isEqual } from 'lodash'
  import FilterRangeDate from './filter-range-date'
  import { decode, encode } from '../query-encoder'

  export default {
    name: 'BtnFilters',
    components: {FilterRangeDate},
    props: {
      value: {},
      endpoint: {},
      data: {},
      date: {},
      range: false,
    },
    data () {
      return {
        filterDate: this.date,
        filtersValue: null,
      }
    },
    computed: {
      hasFilters () {
        // if has filters other than 'map'
        for (let key in this.value) {
          if (this.value.hasOwnProperty(key) && key !== 'map') {
            return true
          }
        }
        return false
      },
      queryFilters () {
        return this.$route.query.filters
          ? decode(this.$route.query.filters)
          : {}
      },
    },
    watch: {
      filterDate () {
        this.$emit('update:date', this.filterDate)
      },
      value () {
        const query = Object.assign({}, this.$route.query)
        if (isEmpty(this.value)) {
          delete query.filters
        } else {
          query.filters = encode(this.value)
        }

        this.$router.replace({query})
      },
      queryFilters (newValue) {
        if (!isEqual(newValue, this.value)) {
          this.filtersValue = newValue
        }
      },
      filtersValue () {
        this.$emit('input', this.filtersValue)
      },
    },
    mounted () {
      this.filtersValue = this.queryFilters
    },
    methods: {
      showFilters () {
        return this.$refs.filters.show()
      },
    },
  }
</script>

<style lang="scss">
  @import "boot";
  .btn-filters-dirty {
    border-color: $primary;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/btn-filters.vue